import React from "react";

const LOGIN = React.lazy(() => import("./Login"));
const SIGN_UP = React.lazy(() => import("./Signup"));
const FORGET_PASSWORD = React.lazy(() => import("./ForgetPassword"));

const AUTH_PAGES = {
  LOGIN,
  SIGN_UP,
  FORGET_PASSWORD,
};
export default AUTH_PAGES;
